<template>
  <v-navigation-drawer
    v-model="drawer"
    absolute
    temporary
    width="360"
  >
    <v-list v-if="!isNavigationDisabled">
      <v-list-item>
        <v-list-item-content>
          <stepper />
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider v-if="!isNavigationDisabled" />
    <v-list-item v-if="!isNavigationDisabled">
      <v-list-item-content>
        <summary-dialog />
      </v-list-item-content>
    </v-list-item>
    <v-divider v-if="!isNavigationDisabled" />
    <v-list-item>
      <v-list-item-content>
        <contract-viewer />
      </v-list-item-content>
    </v-list-item>
  </v-navigation-drawer>
</template>

<script>
  import Stepper from './Stepper.vue'
  import Summary from './Summary.vue'
  import ContractViewer from '../views/ContractViewer.vue'

  export default {
    components: {
      'stepper': Stepper,
      'summary-dialog': Summary,
      'contract-viewer': ContractViewer
    },
    computed: {
      drawer: {
        get () {
          return this.$store.getters.drawer
        },
        set (val) {
          this.$store.commit('setDrawer', val)
        }
      },
      isNavigationDisabled () {
        return this.$store.getters.isNavigationDisabled
      }
    }
  }
</script>
